// Reserve every affected loan synchronously, before awaiting any network work.
const tails = new Map<string, Promise<unknown>>();
export function queueLoanWork<T>(ids: string[], work: () => Promise<T>): Promise<T> {
  const keys = [...new Set(ids)].sort();
  const previous = keys.map((id) => tails.get(id) ?? Promise.resolve());
  const result = Promise.all(previous.map((p) => p.catch(() => undefined))).then(work);
  for (const id of keys) tails.set(id, result);
  void result.finally(() => { for (const id of keys) if (tails.get(id) === result) tails.delete(id); }).catch(() => undefined);
  return result;
}
